<template>
    <a-modal title="自定义群组"
             :width="800"
             :visible="visible"
             @ok="onSave"
             @cancel="onCancel"
             destroyOnClose
             :confirmLoading="confirmLoading">
        <a-form :form="form">
          <a-form-item
              label='群组名称'
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 12 }">
            <a-input v-decorator="[
                            'groupName',
                            {initialValue:formData.groupName, rules: [{ required: true, message: '请填写群组名称' }]}]" placeholder='群组名称'/>
          </a-form-item>
          <a-form-item
              label='顺序号'
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 12 }">
            <a-input-number v-decorator="[
                                    'seqNo',
                                    {initialValue:formData.seqNo, rules: [{ required: true, type: 'number', message: '请填写数字类型顺序号' }]}]" placeholder='顺序号'/>
          </a-form-item>
          <a-form-item
              label='群组成员'
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 14 }">
            <user-selector v-decorator="['groupIds', {initialValue:formData.groupIds,rules: [{ required: true, message: '请选择群组成员' }]}]" multiple selectAllButton showRoot style="width: 100%"/>
          </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'
import UserSelector from '@/components/selector/UserSelector'

export default {
  name: 'LocalGroupEdit',
  components: {
    UserSelector
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      visible: false,
      formData: {}
    }
  },
  methods: {
    preGroupEdit: function (id) {
      this.form.resetFields()
      this.visible = true
      this.loadData(id)
    },
    loadData (id) {
      this.formData.id = id
      this.$http.get('/api/1/workflow/local_group/get_local_group.json?id=' + id).then((resp) => {
        this.formData = resp.result
      })
    },
    onSave () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.confirmLoading = true
        let params = { ...this.formData, ...this.form.getFieldsValue() }
        this.$http.post('/api/1/workflow/local_group/edit_local_group.json', qs.stringify(params)).then((resp) => {
          this.confirmLoading = false
          this.visible = false
          this.$emit('success')
        })
      })
    },
    onCancel () {
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
